import { render, staticRenderFns } from "./VehicleCardSectionRemarks.vue?vue&type=template&id=805b66c4&scoped=true&"
import script from "./VehicleCardSectionRemarks.vue?vue&type=script&lang=js&"
export * from "./VehicleCardSectionRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805b66c4",
  null
  
)

export default component.exports
import {QCardSection,QTr,QTh,QTd,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QCardSection,QTr,QTh,QTd,QBtn,QTooltip}, component.options.components || {})
